import { ROUTE_NAME } from '@/router/utils/const'

export const DISABLE_ROUTES = [
  ROUTE_NAME.SIGNIN,
  ROUTE_NAME.SIGNIN_CONFIRMATION,
  ROUTE_NAME.CONFIRM,
  ROUTE_NAME.SIGNUP,
  ROUTE_NAME.SIGNUP_CONFIRMATION,
  ROUTE_NAME.FORGOT,
  ROUTE_NAME.PASSWORD,
  ROUTE_NAME.PERMISSION_DENIED,
  ROUTE_NAME.UPGRADE_PLAN,
]
